import { QueryClient } from '@tanstack/react-query';

// Shared QueryClient used app-wide for consistent caching/retry behavior.
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60 * 1000,
            refetchOnWindowFocus: false,
            retry: 1,
        },
        mutations: {
            retry: 0,
        },
    },
});
